import React, {Component} from 'react';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

class SourceTool extends Component {

    constructor(props) {
        super(props);
        this.state = {
            btnChecked:false
        }
    }

    render() {
        let style = {};
        if(this.state.btnChecked){
            style.boxShadow = `-1px -1px ${EDITOR_TOOL_BTN_COLOR.checked}`;
        }else{
            if(style.boxShadow){
                delete style.boxShadow;
            }
        }
        return (
            <span className={"editor-source-tool-btn"} style={{fontSize:14, cursor:"pointer",lineHeight:"30px",...style}} onClick={()=>{
                this.props.editor.execCommand("source");
                this.setState({ btnChecked:!this.state.btnChecked },()=>{
                    console.log(this.props.editor.queryCommandState('source'),"编辑器源码开关，1：开；0：关；")
                });
            }}>
                &lt;/&gt;源码
                <style>{`
                    .editor-source-tool-btn{
                        border: 1px solid #f2f6fc
                    }
                    .editor-source-tool-btn:hover{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                    }
                    .editor-source-tool-btn:active{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                    }
                `}</style>
            </span>
        );
    }
}

export default SourceTool;